// B3-8: Admin's review of the approval answers.

const pad = n => String(n).padStart(2, '0')

export function ukDay(d) {
  return d instanceof Date && !isNaN(d.getTime()) ? pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear() : null
}

const SUSPEND = { STOP: 'Suspended: stopped', PAUSE: 'Suspended: paused', SKIP_FIRST: 'Suspended: first email skipped' }

/** One answer in words. */
export function feedbackAnswer(row) {
  if (!row) return ''
  if (row.action === 'APPROVE') return 'Approved as written'
  if (row.action === 'EDIT') return 'Edited, then approved'
  if (row.action === 'SUSPEND') {
    var s = SUSPEND[row.suspendOption] || 'Suspended'
    return row.suspendOption === 'PAUSE' && row.pauseDays ? s + ' ' + row.pauseDays + ' days' : s
  }
  return row.action || ''
}

/** "12 answers: 8 approved, 3 edited, 1 suspended". */
export function feedbackCounts(rows) {
  var n = a => rows.filter(r => r.action === a).length
  return rows.length + (rows.length === 1 ? ' answer: ' : ' answers: ') + n('APPROVE') + ' approved, ' + n('EDIT') + ' edited, ' + n('SUSPEND') + ' suspended'
}
